import type { QueryKey } from '@tanstack/react-query';
import { get } from '../../../../redux/api';
import { useQuery } from '../../../../ReactQuery';
import type { Plan } from '../../../../../shared/subscriptions';

// We can keep this data around for a bit longer since plans don't change often.
const STALE_TIME = 1000 * 60 * 15; // 15 minutes

function fetchPlans() {
  return get<Plan[]>(`/api/plans`);
}

const getQueryKey = (): QueryKey => ['plans'];

/**
 * Fetches the plans
 */
export default function usePlans() {
  return useQuery<Plan[]>({
    queryKey: getQueryKey(),
    queryFn: () => fetchPlans(),
    staleTime: STALE_TIME,
  });
}
